export default __webpack_public_path__ + "static/media/x-footer.faf8a43e.svg";